<template>
  <GModal ref="modalUserPhotos" class="modal--edit-review">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
      </button>

      <h2 class="modal-heading">
        <img src="/assets/img/icons/write-review-circle-v2.svg" alt="SOCO" class="icon icon__write-review" />Edit Review
      </h2>
    </div>

    <div slot="body">
      <div class="page--create-review">
        <div v-if="screen.width > 740" class="show-desktop">
          <div class="head">
            <div class="product-display">
              <div class="product-display__thumb">
                <img
                  v-if="review.product.combination.images && review.product.combination.images.length"
                  :src="review.product.combination.images[0].url"
                  onerror="this.src='/assets/img/dummy_product.svg'"
                  :alt="review.product.name"
                />
                <img v-else src="/assets/img/dummy_product.svg" alt="SOCO" />
              </div>

              <div class="product-display__content">
                <h5 v-if="review.product.brand" class="manufacture-name">{{ review.product.brand.name }}</h5>
                <p class="product-name">{{ review.product.name }}</p>
                <p v-if="review.product.variant" class="attribute-name">{{ review.product.variant | stripHTML }}</p>
                <p v-else class="attribute-name">{{ showProductDetail(review.product.combination) | stripHTML }}</p>
              </div>
            </div>
          </div>

          <div class="container content-create-review">
            <div v-if="!user.is_expert_reviewer" class="info-edit-review">
              <img src="/assets/img/exclamation-mark.svg" class="info-edit-review__icon" />
              <p class="info-edit-review__info">You can only edit this review 1 time</p>
            </div>

            <form class="form-write-review" @submit.prevent>
              <div class="row">
                <div class="col-md-12 col-xs-12">
                  <div class="form-input-group">
                    <div v-if="$SO.size(review.lisRatingTypes)" class="form-group">
                      <label class="form-label">Give Ratings <span class="input-mandatory">*</span></label>
                      <div class="list-rating">
                        <ReviewRating
                          v-for="(rating, key) in review.lisRatingTypes"
                          :key="key"
                          :rating-types="review.ratingTypes"
                          :title="rating"
                          :name="rating"
                          @getRating="setRating"
                        >
                        </ReviewRating>
                      </div>
                      <input v-model="allRating" v-validate="'required'" type="hidden" name="rating" />
                      <p v-show="errors.has('rating')" class="text-error">Semua rating belum diisi</p>

                      <div class="average-rating-wrapper">
                        <div class="average-rating">
                          <h4 class="average-rating__heading">Average Rating</h4>
                          <div class="average-rating__value">
                            <img v-if="averageRating" src="/assets/img/icons/rating-big.svg" alt="icon-rating" />
                            <img v-else src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" />
                            {{ averageRating }}
                          </div>
                        </div>
                        <div class="average-rating__divider"></div>
                      </div>
                    </div>

                    <div class="divider"></div>

                    <div class="form-group">
                      <label class="form-label">Write A Review <span class="input-mandatory">*</span></label>
                      <span class="text-helped-counter" :class="{ passed: details.length >= 150 }"
                        >{{ details.length }} / <b>150</b></span
                      >
                      <textarea
                        v-model="details"
                        v-validate="'required|min:150'"
                        :placeholder="txtPlaceholder"
                        class="form-control textarea-review"
                        name="content_review"
                        data-vv-as="review"
                      >
                      </textarea>
                      <p v-show="errors.has('content_review')" class="text-error">
                        {{ errors.first('content_review') }}
                      </p>
                    </div>

                    <div class="divider"></div>

                    <div class="form-group">
                      <label class="form-label">How long have you been using this product</label>
                      <div class="row">
                        <div class="col-md-3 col-xs-6">
                          <label class="radio-donut m-b-16">
                            <input v-model="duration_of_used" type="radio" name="type" value="Less than 1 Week" /> Less
                            than 1 week
                            <span></span>
                          </label>
                          <label class="radio-donut m-b-16">
                            <input v-model="duration_of_used" type="radio" name="type" value="1 Week - 1 Month" /> 1
                            Week - 1 Month
                            <span></span>
                          </label>
                          <label class="radio-donut m-b-16">
                            <input v-model="duration_of_used" type="radio" name="type" value="1 - 3 Months" /> 1 - 3
                            Months
                            <span></span>
                          </label>
                        </div>
                        <div class="col-md-3 col-xs-6">
                          <label class="radio-donut m-b-16">
                            <input v-model="duration_of_used" type="radio" name="type" value="3 - 6 Months" /> 3 - 6
                            Months
                            <span></span>
                          </label>
                          <label class="radio-donut m-b-16">
                            <input v-model="duration_of_used" type="radio" name="type" value="6 Months - 1 Year" /> 6
                            Months - 1 Year
                            <span></span>
                          </label>
                          <label class="radio-donut m-b-16">
                            <input v-model="duration_of_used" type="radio" name="type" value="More than 1 Year" /> More
                            than 1 Year
                            <span></span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="divider"></div>

                    <div class="form-group">
                      <label class="form-label">Add photo </label>
                      <div class="custom-input-product-shot">
                        <span class="text-helped">Add photos (max. 6 photos & max. 5 MB).</span>
                        <!-- <button type="button" class="btn btn_icon-camera" @click.prevent="openModalUploadPhoto" v-if="productShot.length < 6">ADD PHOTOS</button> -->
                      </div>

                      <ul class="list-product-shot" :class="{ filled: productShot.length }">
                        <li
                          v-if="productShot.length < 6"
                          class="product-shot product-shot--add-photos"
                          @click.prevent="openModalUploadPhoto"
                        ></li>
                        <template v-if="productShot.length">
                          <li v-for="(productPhoto, key) in productShot" :key="key" class="product-shot">
                            <img :src="productPhoto.file" class="product-shot__img" alt="SOCO" />
                            <a href="" class="product-shot__info" @click.prevent="editProductShot(key)">Edit caption</a>
                            <a href="" class="product-shot__remove" @click.prevent="confirmationRemovePhoto(key)"></a>
                          </li>
                        </template>
                      </ul>
                    </div>

                    <div class="divider"></div>

                    <!-- <div class="form-group custom-input-tagging">
											<label class="form-label">Add tag </label>
											<div class="fieldarea fieldarea--multiselect fieldarea--multiselect--tag">
												<Multiselect
													v-model="tags"
													id="ajax"
													label="name"
													placeholder=""
													open-direction="bottom"
													:options="options.tag"
													:multiple="true"
													:searchable="true"
													:loading="state.tag.isLoading"
													:internal-search="false"
													:clear-on-select="true"
													:close-on-select="true"
													:options-limit="300"
													:max-height="600"
													:show-no-results="true"
													:hide-selected="true"
													:showNoOptions="false"
													@search-change="searchTag"
													:show-labels="false"
													track-by="name"
													ref="multiselect"
													@select="onSelected"
												>
												    <template slot="clear" slot-scope="props">
												      <div class="multiselect__clear" v-if="optionTags.length === 0" @mousedown.prevent.stop="clearAll"></div>
												    </template>
												    <span slot="noResult">Tag not found</span>
												</Multiselect>
											</div>
										</div> -->

                    <div v-if="$SO.size(review)" class="form-group section-opinion">
                      <div class="row">
                        <div class="col-md-5 col-xs-12 recommend-new">
                          <img :src="pathEmojiRecomended" class="section-opinion__emoji" alt="SOCO" />

                          <p class="text">Will you recommend this product? <span class="input-mandatory">*</span></p>

                          <div id="is_recommended" class="radio-button">
                            <div class="radio-button__option" :class="{ active: isRecommended === 'yes' }">
                              <input
                                id="recommend-yes"
                                v-model="isRecommended"
                                v-validate="'required'"
                                class="text"
                                name="is_recommended"
                                type="radio"
                                value="yes"
                                data-vv-as="recommend"
                              />
                              <label for="recommend-yes" class="radio-button__label">Yes Absolutely !</label>
                            </div>
                            <div class="radio-button__option" :class="{ active: isRecommended === 'no' }">
                              <input
                                id="recommend-no"
                                v-model="isRecommended"
                                v-validate="'required'"
                                class="text"
                                name="is_recommended"
                                type="radio"
                                value="no"
                                data-vv-as="recommend"
                              />
                              <label for="recommend-no" class="radio-button__label">No</label>
                            </div>
                          </div>
                          <p v-show="errors.has('is_recommended')" class="text-error">
                            {{ errors.first('is_recommended') }}
                          </p>
                        </div>

                        <div class="col-md-7 col-xs-12 repurchase-new">
                          <img :src="pathEmojiRepurchase" class="section-opinion__emoji" alt="SOCO" />

                          <p class="text">Will you repurchase this product ? <span class="input-mandatory">*</span></p>

                          <div id="is_repurchase" class="radio-button">
                            <div class="radio-button__option" :class="{ active: isRepurchase === 'yes' }">
                              <input
                                id="repurchase-yes"
                                v-model="isRepurchase"
                                v-validate="'required'"
                                class="text"
                                name="is_repurchase"
                                type="radio"
                                value="yes"
                                data-vv-as="repurchase"
                              />
                              <label for="repurchase-yes" class="radio-button__label">Yes</label>
                            </div>
                            <div class="radio-button__option" :class="{ active: isRepurchase === 'no' }">
                              <input
                                id="repurchase-no"
                                v-model="isRepurchase"
                                v-validate="'required'"
                                class="text"
                                name="is_repurchase"
                                type="radio"
                                value="no"
                                data-vv-as="repurchase"
                              />
                              <label for="repurchase-no" class="radio-button__label">No !</label>
                            </div>
                            <div class="radio-button__option" :class="{ active: isRepurchase === 'maybe' }">
                              <input
                                id="repurchase-maybe"
                                v-model="isRepurchase"
                                v-validate="'required'"
                                class="text"
                                name="is_repurchase"
                                type="radio"
                                value="maybe"
                                data-vv-as="repurchase"
                              />
                              <label for="repurchase-maybe" class="radio-button__label">Maybe</label>
                            </div>
                          </div>
                          <p v-show="errors.has('is_repurchase')" class="text-error">
                            {{ errors.first('is_repurchase') }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div v-if="isAdminRole" class="form-group custom-input-fake-user">
                      <label class="form-label">Create Review as <span class="input-mandatory">*</span></label>
                      <span class="text-helped text-helped--copywriting-login-admin"
                        >You are logged in as admin, you can select and act as another user to review this
                        product.</span
                      >
                      <div class="fieldarea fieldarea--multiselect">
                        <Multiselect
                          v-model="review.user"
                          v-validate="'required'"
                          :options="options.fakeUser"
                          placeholder="Type to search user"
                          label="name"
                          track-by="name"
                          :loading="state.fakeUser.isLoading"
                          :show-labels="false"
                          open-direction="bottom"
                          :searchable="true"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="600"
                          :show-no-results="false"
                          :hide-selected="true"
                          name="user"
                          @search-change="searchUser"
                        >
                          <span slot="noResult">User not found</span>
                        </Multiselect>
                      </div>
                      <p v-show="errors.has('user')" class="text-error">{{ errors.first('user') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div v-if="screen.width <= 740" class="show-mobile">
          <GModal class="modal--full-fixed">
            <div slot="header">
              <button type="button" class="close" aria-label="Close">
                <img src="/assets/img/icons/back.svg" alt="SOCO" @click.prevent="backStep" />
              </button>

              <h2 class="modal-heading modal-heading__header">{{ copywritingHeadingMobile }}</h2>
            </div>

            <div slot="body">
              <div v-if="!screen.isDesktop" class="parent-progress">
                <span class="counter-progress">{{ captionProgress }}</span>
                <div class="progress">
                  <div class="progress-bar" :style="{ width: widthProgress }"></div>
                </div>
              </div>

              <div v-show="layerSteps.give_rating" class="give-rating-state">
                <div>
                  <div
                    class="wallpaper"
                    :class="{ 'wallpaper--bigger': $SO.size(review.ratingTypes) && $SO.size(review.ratingTypes) > 4 }"
                  ></div>
                  <div class="head">
                    <div class="product-display">
                      <div class="product-display__thumb">
                        <img
                          v-if="review.images"
                          :src="review.product.images[0].url"
                          onerror="this.src='/assets/img/dummy_product.svg'"
                          :alt="review.product.name"
                        />
                        <img v-else src="/assets/img/dummy_product.svg" alt="SOCO" />
                      </div>

                      <div class="product-display__content">
                        <h5 v-if="review.product.brand" class="manufacture-name">{{ review.product.brand.name }}</h5>
                        <p class="product-name">{{ convertName(review.product.name) }}</p>
                        <p v-if="review.product.variant" class="attribute-name">
                          {{ review.product.variant | stripHTML }}
                        </p>
                      </div>
                    </div>

                    <div v-if="!user.is_expert_reviewer" class="info-edit-review">
                      <img src="/assets/img/exclamation-mark.svg" class="info-edit-review__icon" />
                      <p class="info-edit-review__info">You can only edit this review 1 time</p>
                    </div>

                    <h2 class="text-give-rating">Rate your experience with this product</h2>

                    <div v-if="$SO.size(review.lisRatingTypes)" class="list-rating">
                      <ReviewRating
                        v-for="(rating, key) in review.lisRatingTypes"
                        :key="key"
                        :rating-types="review.ratingTypes"
                        :title="rating"
                        :name="rating"
                        @getRating="setRating"
                      >
                      </ReviewRating>
                    </div>
                    <input v-model="allRating" v-validate="'required'" type="hidden" name="rating" />
                    <p v-show="errors.has('rating')" class="text-error">Semua rating belum diisi</p>

                    <div v-if="allRating" class="average-rating-wrapper">
                      <div class="average-rating">
                        <h4 class="average-rating__heading">Your rating</h4>
                        <div class="average-rating__bottom">
                          <div class="average-rating__caption">
                            {{ captionRating(averageRating) }}
                          </div>
                          <div class="average-rating__value">
                            <img v-if="averageRating" src="/assets/img/icons/rating-big.svg" alt="icon-rating" />
                            <img v-else src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" />
                            {{ averageRating }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="layerSteps.write_review" class="write-review-state">
                <!-- <div class="wallpaper"></div>
						    <div class="average-rating-wrapper">
						    	<div class="average-rating">
						    		<h4 class="average-rating__heading">AVERAGE RATING</h4>
						    		<div class="average-rating__value">
						    			<img src="/assets/img/icons/rating-big.svg" alt="icon-rating" v-if="averageRating" />
						    			<img src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" v-else />
						    			{{ averageRating }}
						    		</div>
						    	</div>
						    </div> -->

                <div class="new-wrapper-rating">
                  <div class="average-rating">
                    <div class="average-rating__left">
                      <h4 class="average-rating__heading">Your rating</h4>
                      <div class="average-rating__caption">
                        {{ captionRating(averageRating) }}
                      </div>
                    </div>
                    <div class="average-rating__value">
                      <img v-if="averageRating" src="/assets/img/icons/rating-big.svg" alt="icon-rating" />
                      <img v-else src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" />
                      {{ averageRating }}
                    </div>
                  </div>
                </div>

                <div class="p-16">
                  <div class="form-group">
                    <label class="form-label">Write A Review <span class="input-mandatory">*</span></label>
                    <span class="text-helped-counter" :class="{ passed: details.length >= 150 }"
                      >{{ details.length }} / <b>150</b></span
                    >
                    <textarea
                      v-model="details"
                      v-validate="'required|min:150'"
                      :placeholder="txtPlaceholder"
                      class="form-control textarea-review"
                      name="content_review"
                      data-vv-as="review"
                    >
                    </textarea>
                    <p v-show="errors.has('content_review')" class="text-error">{{ errors.first('content_review') }}</p>
                  </div>

                  <div class="divider"></div>

                  <div class="form-group section-using-product">
                    <label class="form-label">How long have you used this product?</label>
                    <div class="row">
                      <div class="radio-button">
                        <div class="radio-button__option" :class="{ active: duration_of_used === 'Less than 1 Week' }">
                          <input
                            id="less-than-1-week"
                            v-model="duration_of_used"
                            class="text"
                            name="type"
                            type="radio"
                            value="Less than 1 Week"
                          />
                          <label for="less-than-1-week" class="radio-button__label">Less than 1 week</label>
                        </div>
                        <div class="radio-button__option" :class="{ active: duration_of_used === '1 Week - 1 Month' }">
                          <input
                            id="1-week-1-month"
                            v-model="duration_of_used"
                            class="text"
                            name="type"
                            type="radio"
                            value="1 Week - 1 Month"
                          />
                          <label for="1-week-1-month" class="radio-button__label">1 Week - 1 Month</label>
                        </div>
                        <div class="radio-button__option" :class="{ active: duration_of_used === '1 - 3 Months' }">
                          <input
                            id="1-3-months"
                            v-model="duration_of_used"
                            class="text"
                            name="type"
                            type="radio"
                            value="1 - 3 Months"
                          />
                          <label for="1-3-months" class="radio-button__label">1 - 3 Months</label>
                        </div>
                        <div class="radio-button__option" :class="{ active: duration_of_used === '3 - 6 Months' }">
                          <input
                            id="3-6-months"
                            v-model="duration_of_used"
                            class="text"
                            name="type"
                            type="radio"
                            value="3 - 6 Months"
                          />
                          <label for="3-6-months" class="radio-button__label">3 - 6 Months</label>
                        </div>
                        <div class="radio-button__option" :class="{ active: duration_of_used === '6 Months - 1 Year' }">
                          <input
                            id="6-months-1-year"
                            v-model="duration_of_used"
                            class="text"
                            name="type"
                            type="radio"
                            value="6 Months - 1 Year"
                          />
                          <label for="6-months-1-year" class="radio-button__label">6 Months - 1 Year</label>
                        </div>
                        <div class="radio-button__option" :class="{ active: duration_of_used === 'More than 1 Year' }">
                          <input
                            id="more-than-1-year"
                            v-model="duration_of_used"
                            class="text"
                            name="type"
                            type="radio"
                            value="More than 1 Year"
                          />
                          <label for="more-than-1-year" class="radio-button__label">More than 1 Year</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider"></div>

                  <div class="form-group">
                    <label class="form-label form-label-photo">Add Photo </label>
                    <div class="custom-input-product-shot">
                      <span class="text-helped">Add photos (max. 6 photos & max. 5 MB).</span>
                      <!-- <button type="button" class="btn btn_icon-camera" @click.prevent="openModalUploadPhoto" v-if="productShot.length < 6">ADD PHOTOS</button> -->
                    </div>

                    <ul class="list-product-shot" :class="{ filled: productShot.length }">
                      <!-- <li class="product-shot product-shot--add-photos" @click.prevent="openModalUploadPhoto" v-if="productShot.length < 6"></li> -->
                      <template v-if="productShot.length">
                        <li v-for="(productPhoto, key) in productShot" :key="key" class="product-shot">
                          <img :src="productPhoto.file" class="product-shot__img" alt="SOCO" />
                          <a href="" class="product-shot__info" @click.prevent="editProductShot(key)">Edit caption</a>
                          <a href="" class="product-shot__remove" @click.prevent="confirmationRemovePhoto(key)"></a>
                        </li>
                      </template>
                      <li v-if="productShot.length < 6" class="product-shot product-shot--add-photos">
                        <form
                          v-show="temporaryProductShot.length === 0"
                          ref="bjUploader"
                          method="post"
                          action=""
                          enctype="multipart/form-data"
                          class=""
                        >
                          <input
                            type="file"
                            class="product-shot product-shot--add-photos"
                            accept="image/png, image/jpeg, image/jpg"
                            multiple
                            @change="onProcessFile($event)"
                          />
                        </form>
                      </li>
                    </ul>
                  </div>

                  <div class="divider"></div>

                  <!-- <div class="form-group custom-input-tagging">
									<label class="form-label">Add tag </label>
									<div class="fieldarea fieldarea--multiselect fieldarea--multiselect--tag">
										<Multiselect
											v-model="tags"
											id="ajax"
											label="name"
											placeholder=""
											open-direction="bottom"
											:options="options.tag"
											:multiple="true"
											:searchable="true"
											:loading="state.tag.isLoading"
											:internal-search="false"
											:clear-on-select="true"
											:close-on-select="true"
											:options-limit="300"
											:max-height="600"
											:show-no-results="true"
											:hide-selected="true"
											:showNoOptions="false"
											@search-change="searchTag"
											:show-labels="false"
											track-by="name"
											ref="multiselect"
											@select="onSelected"
										>
											<template slot="clear" slot-scope="props">
											<div class="multiselect__clear" v-if="optionTags.length === 0" @mousedown.prevent.stop="clearAll"></div>
											</template>
											<span slot="noResult">Tag not found</span>
										</Multiselect>
									</div>
								</div> -->

                  <div class="form-group section-opinion">
                    <label class="form-label form-label-recommend">Will you recommend this product?</label>
                    <div class="row">
                      <div id="is_recommended" class="radio-button">
                        <div class="radio-button__option" :class="{ active: isRecommended === 'yes' }">
                          <input
                            id="recommend-yes"
                            v-model="isRecommended"
                            v-validate="'required'"
                            class="text"
                            name="is_recommended"
                            type="radio"
                            value="yes"
                            data-vv-as="recommend"
                          />
                          <label for="recommend-yes" class="radio-button__label">
                            <img :src="pathEmojiRecomendedYes" class="section-opinion__emoji" alt="SOCO" /> Yes
                            Absolutely !
                          </label>
                        </div>
                        <div class="radio-button__option" :class="{ active: isRecommended === 'no' }">
                          <input
                            id="recommend-no"
                            v-model="isRecommended"
                            v-validate="'required'"
                            class="text"
                            name="is_recommended"
                            type="radio"
                            value="no"
                            data-vv-as="recommend"
                          />
                          <label for="recommend-no" class="radio-button__label">
                            <img :src="pathEmojiRecomendedNo" class="section-opinion__emoji" alt="SOCO" /> No
                          </label>
                        </div>
                      </div>
                      <p v-show="errors.has('is_recommended')" class="text-error">
                        {{ errors.first('is_recommended') }}
                      </p>
                    </div>
                  </div>

                  <div class="divider"></div>

                  <div class="form-group section-opinion">
                    <label class="form-label form-label-recommend">Will you repurchase this product ? </label>
                    <div class="row">
                      <div id="is_repurchase" class="radio-button">
                        <div class="radio-button__option" :class="{ active: isRepurchase === 'yes' }">
                          <input
                            id="repurchase-yes"
                            v-model="isRepurchase"
                            v-validate="'required'"
                            class="text"
                            name="is_repurchase"
                            type="radio"
                            value="yes"
                            data-vv-as="repurchase"
                          />
                          <label for="repurchase-yes" class="radio-button__label">
                            <img :src="pathEmojiRepurchaseYes" class="section-opinion__emoji" alt="SOCO" />Yes
                          </label>
                        </div>
                        <div class="radio-button__option" :class="{ active: isRepurchase === 'no' }">
                          <input
                            id="repurchase-no"
                            v-model="isRepurchase"
                            v-validate="'required'"
                            class="text"
                            name="is_repurchase"
                            type="radio"
                            value="no"
                            data-vv-as="repurchase"
                          />
                          <label for="repurchase-no" class="radio-button__label">
                            <img :src="pathEmojiRepurchaseNo" class="section-opinion__emoji" alt="SOCO" />No !
                          </label>
                        </div>
                        <div class="radio-button__option" :class="{ active: isRepurchase === 'maybe' }">
                          <input
                            id="repurchase-maybe"
                            v-model="isRepurchase"
                            v-validate="'required'"
                            class="text"
                            name="is_repurchase"
                            type="radio"
                            value="maybe"
                            data-vv-as="repurchase"
                          />
                          <label for="repurchase-maybe" class="radio-button__label">
                            <img :src="pathEmojiRepurchaseMaybe" class="section-opinion__emoji" alt="SOCO" />Maybe
                          </label>
                        </div>
                      </div>
                      <p v-show="errors.has('is_repurchase')" class="text-error">{{ errors.first('is_repurchase') }}</p>
                    </div>
                  </div>

                  <div class="divider"></div>

                  <div v-if="isAdminRole" class="form-group custom-input-fake-user">
                    <label class="form-label">Create Review as <span class="input-mandatory">*</span></label>
                    <span class="text-helped text-helped--copywriting-login-admin"
                      >You are logged in as admin, you can select and act as another user to review this product.</span
                    >
                    <div class="fieldarea fieldarea--multiselect">
                      <Multiselect
                        v-model="review.user"
                        v-validate="'required'"
                        :options="options.fakeUser"
                        placeholder="Type to search user"
                        label="name"
                        track-by="name"
                        :loading="state.fakeUser.isLoading"
                        :show-labels="false"
                        open-direction="bottom"
                        :searchable="true"
                        :internal-search="false"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="true"
                        name="user"
                        @search-change="searchUser"
                      >
                        <span slot="noResult">User not found</span>
                      </Multiselect>
                    </div>
                    <p v-show="errors.has('user')" class="text-error">{{ errors.first('user') }}</p>
                  </div>
                </div>
              </div>

              <div v-show="layerSteps.recommend" class="recommend-state">
                <div class="wallpaper"></div>
                <div class="average-rating-wrapper">
                  <div class="average-rating">
                    <h4 class="average-rating__heading">Average Rating</h4>
                    <div class="average-rating__value">
                      <img v-if="averageRating" src="/assets/img/icons/rating-big.svg" alt="icon-rating" />
                      <img v-else src="/assets/img/icons/rating-big-disabled.svg" alt="icon-rating" />
                      {{ averageRating }}
                    </div>
                  </div>
                </div>

                <!-- <div class="form-group section-opinion" v-if="$SO.size(review)">
						    	<div class="row">
						    		<div class="col-md-5 col-xs-12 recommend">
						    			<img :src="pathEmojiRecomended" class="section-opinion__emoji" alt="SOCO"/>

						    			<p class="text">Will you recommend this product? <span class="input-mandatory">*</span></p>

						    			<div class="radio-button" id="is_recommended">
						    				<div class="radio-button__option" :class="{active: (isRecommended === 'yes')}">
						    					<input id="recommend-yes" class="text" name="is_recommended" type="radio" value="yes" v-model="isRecommended" v-validate="'required'" data-vv-as="recommend">
						    					<label for="recommend-yes" class="radio-button__label">Yes Absolutely !</label>
						    				</div>
						    				<div class="radio-button__option" :class="{active: (isRecommended === 'no')}">
						    					<input id="recommend-no" class="text" name="is_recommended" type="radio" value="no" v-model="isRecommended" v-validate="'required'" data-vv-as="recommend">
						    					<label for="recommend-no" class="radio-button__label">No</label>
						    				</div>
						    			</div>
						    			<p v-show="errors.has('is_recommended')" class="text-error">{{ errors.first('is_recommended') }}</p>
						    		</div>
						    		<div class="divider"></div>
						    		<div class="col-md-7 col-xs-12 repurchase">
						    			<img :src="pathEmojiRepurchase" class="section-opinion__emoji" alt="SOCO"/>

						    			<p class="text">Will you repurchase this product ? <span class="input-mandatory">*</span></p>

						    			<div class="radio-button" id="is_repurchase">
						    				<div class="radio-button__option" :class="{active: (isRepurchase === 'yes')}">
						    					<input id="repurchase-yes" class="text" name="is_repurchase" type="radio" value="yes" v-model="isRepurchase" v-validate="'required'" data-vv-as="repurchase">
						    					<label for="repurchase-yes" class="radio-button__label">Yes Absolutely</label>
						    				</div>
						    				<div class="radio-button__option" :class="{active: (isRepurchase === 'no')}">
						    					<input id="repurchase-no" class="text" name="is_repurchase" type="radio" value="no" v-model="isRepurchase" v-validate="'required'" data-vv-as="repurchase">
						    					<label for="repurchase-no" class="radio-button__label">No !</label>
						    				</div>
						    				<div class="radio-button__option" :class="{active: (isRepurchase === 'maybe')}">
						    					<input id="repurchase-maybe" class="text" name="is_repurchase" type="radio" value="maybe" v-model="isRepurchase" v-validate="'required'" data-vv-as="repurchase">
						    					<label for="repurchase-maybe" class="radio-button__label">Maybe</label>
						    				</div>
						    			</div>
						    			<p v-show="errors.has('is_repurchase')" class="text-error">{{ errors.first('is_repurchase') }}</p>
						    		</div>
						    	</div>
						    </div> -->
              </div>
            </div>

            <div slot="footer">
              <template v-if="layerSteps.write_review">
                <a href="" class="btn btn-next" :class="{ disabled: disabledNext }" @click.prevent="confirmation"
                  >Save</a
                >
              </template>
              <a v-else href="" class="btn btn-next" :class="{ disabled: disabledNext }" @click.prevent="nextStep"
                >Next</a
              >
            </div>
          </GModal>
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="create-review-text">
        <button
          type="button"
          class="btn btn_black btn_publish"
          :class="{ disabled: disabledPublishDesktop }"
          @click.prevent="confirmation"
        >
          Save
        </button>
      </div>
    </div>
  </GModal>
</template>

<script>
let CancelToken;
let source;

import Multiselect from 'vue-multiselect';
import ReviewRating from '@/components/review/review-create/snippet/review-rating';
import Compressor from 'compressorjs';

export default {
  name: 'ModalEditReview',
  components: {
    Multiselect,
    ReviewRating,
  },
  data() {
    return {
      layerSteps: {
        give_rating: true,
        write_review: false,
        recommend: false,
      },
      options: {
        tag: [],
        fakeUser: [],
      },
      isLoadingProduct: false,
      state: {
        onProgressSubmit: false,
        tag: {
          isLoading: false,
        },
        fakeUser: {
          isLoading: false,
        },
      },
      editPhoto: {
        file: '',
        caption: '',
      },
      temp: {
        fakeUser: '',
      },
    };
  },
  computed: {
    allRating() {
      let isTrueTotal = 0;
      let length;

      if (!this.$SO.isEmptyObject(this.review.ratingTypes)) {
        length = this.$SO.size(this.review.ratingTypes);
        this.$SO.each(
          this.review.ratingTypes,
          function (key, val) {
            if (this.review.ratingTypes[key].value) {
              isTrueTotal++;
            }
          }.bind(this)
        );

        if (length === isTrueTotal) {
          return 'has data';
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    averageRating() {
      let total = 0;
      let length;

      if (!this.$SO.isEmptyObject(this.review.ratingTypes)) {
        length = this.$SO.size(this.review.ratingTypes);
        this.$SO.each(
          this.review.ratingTypes,
          function (key, val) {
            if (this.review.ratingTypes[key].value) {
              total += this.review.ratingTypes[key].value;
            }
          }.bind(this)
        );

        if (total) {
          return (total / length).toFixed(1);
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    copywritingHeadingMobile() {
      let copy = '';
      if (this.layerSteps.give_rating) {
        copy = 'Give Rating';
      } else if (this.layerSteps.write_review) {
        copy = 'Write Review';
      } else if (this.layerSteps.recommend) {
        copy = 'Recommend & Repurchase';
      }
      return copy;
    },
    details: {
      get() {
        return this.$store.state.modal.editReview.data.details;
      },
      set(value) {
        this.$store.commit('setReviewDetails', value.replace(/\s\s+/g, ' '));
      },
    },
    disabledNext() {
      if (this.layerSteps.give_rating) {
        return !this.allRating;
      } else if (this.layerSteps.write_review) {
        return this.details.length === 0 || this.errors.has('content_review');
      } else if (this.layerSteps.recommend) {
        return !this.isRecommended || !this.isRepurchase;
      } else {
        return false;
      }
    },
    disabledPublishDesktop() {
      return (
        !this.allRating ||
        this.details.length < 150 ||
        !this.isRecommended ||
        !this.isRepurchase ||
        !this.duration_of_used
      );
    },
    isAdminRole() {
      return this.user && this.user.role.includes('admin');
    },
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    pathEmojiRecomended() {
      if (this.isRecommended === 'yes') {
        return `/assets/img/icons/yes-emoji.svg`;
      } else if (this.isRecommended === 'no') {
        return `/assets/img/icons/no-emoji.svg`;
      } else {
        return `/assets/img/icons/default-recomendation-emoji.svg`;
      }
    },
    pathEmojiRepurchase() {
      if (this.isRepurchase === 'yes') {
        return `/assets/img/icons/yes-emoji.svg`;
      } else if (this.isRepurchase === 'maybe') {
        return `/assets/img/icons/maybe-emoji.svg`;
      } else if (this.isRepurchase === 'no') {
        return `/assets/img/icons/no-emoji.svg`;
      } else {
        return `/assets/img/icons/default-recomendation-emoji.svg`;
      }
    },
    pathEmojiRecomendedYes() {
      if (this.isRecommended === 'yes') {
        return `/assets/img/icons/icon-recommend-yes.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-yes-gray.svg`;
      }
    },
    pathEmojiRecomendedNo() {
      if (this.isRecommended === 'no') {
        return `/assets/img/icons/icon-recommend-no.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-no-gray.svg`;
      }
    },
    pathEmojiRepurchaseYes() {
      if (this.isRepurchase === 'yes') {
        return `/assets/img/icons/icon-recommend-yes.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-yes-gray.svg`;
      }
    },
    pathEmojiRepurchaseNo() {
      if (this.isRepurchase === 'no') {
        return `/assets/img/icons/icon-recommend-no.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-no-gray.svg`;
      }
    },
    pathEmojiRepurchaseMaybe() {
      if (this.isRepurchase === 'maybe') {
        return `/assets/img/icons/icon-recommend-maybe.svg`;
      } else {
        return `/assets/img/icons/icon-recommend-maybe-gray.svg`;
      }
    },
    isRepurchase: {
      get() {
        return this.$store.state.modal.editReview.data.is_repurchase;
      },
      set(value) {
        this.$store.commit('setReviewIsRepurchase', value);
      },
    },
    isRecommended: {
      get() {
        return this.$store.state.modal.editReview.data.is_recommended;
      },
      set(value) {
        this.$store.commit('setReviewIsRecommended', value);
      },
    },
    review() {
      return this.$store.state.modal.editReview.data;
    },
    productShot() {
      return this.$store.state.writeReview.productShot;
    },
    showModalCombination() {
      return this.$store.state.modal.isModalShow.combination;
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    queryStringCombinationId() {
      return this.$route.query.combination_id;
    },
    tags: {
      get() {
        return this.$store.state.modal.editReview.data.tags;
      },
      set(value) {
        this.$store.commit('setReviewTags', value);
      },
    },
    duration_of_used: {
      get() {
        return this.$store.state.modal.editReview.data.duration_of_used;
      },
      set(value) {
        this.$store.commit('setReviewDurationUsage', value);
      },
    },
    widthProgress() {
      let value = '';
      if (this.layerSteps.give_rating) {
        value = '60%';
      } else if (this.layerSteps.write_review) {
        value = '100%';
      } else if (this.layerSteps.recommend) {
        value = '100%';
      }
      return value;
    },
    captionProgress() {
      let caption = '';
      if (this.layerSteps.give_rating) {
        caption = '2 of 3';
      } else if (this.layerSteps.write_review) {
        caption = '3 of 3';
      } else if (this.layerSteps.recommend) {
        caption = '3 of 3';
      }
      return caption;
    },
    screen() {
      return this.$store.state.screen;
    },
    temporaryProductShot() {
      return this.$store.state.writeReview.temporaryProductShot;
    },
    productCombinationsAttribute() {
      const combinations = this.review.product ? this.review.product.combination : [];
      const updatedCombinations = [];
      if (typeof combinations === 'object') {
        updatedCombinations.push(combinations);
      }
      return updatedCombinations.map((el) => {
        const variant = [];
        const attributeGroup = ['Shade', 'Variant', 'Size', 'Color', 'Non_specify'];

        if (el.attribute) {
          attributeGroup.forEach((group) => {
            const groupLower = group.toLowerCase();
            if (el.attribute[groupLower]) {
              variant.push({
                group,
                ...el.attribute[groupLower],
              });
            }
          });
        } else {
          attributeGroup.forEach((group) => {
            const groupLower = group.toLowerCase();
            if (el.attributes[groupLower]) {
              variant.push({
                group,
                ...el.attributes[groupLower],
              });
            }
          });
        }

        return {
          id: el._id ? el._id : el.id,
          label: variant.map((attr) => attr.name).join(' - '),
          variant: variant.map((attr) => `${attr.group}: ${attr.name}`).join(', '),
          attribute: el.attribute ? el.attribute : el.attributes,
          is_active_in_review: el.is_active_in_review,
        };
      });
    },
    txtPlaceholder() {
      return `Tell us what you like about this product! \nFor example: Love this, it absorbs easily & gives that instant glowing effect! 😍`;
    },
  },
  mounted() {
    this.toggleHeightMultiselect();
  },
  updated() {
    this.toggleHeightMultiselect();
  },
  beforeDestroy() {
    this.$store.commit('resetDataRelatedWriteReview');
  },
  methods: {
    closeModal() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'editReview' });
    },
    onSelected() {
      this.$nextTick(() => this.$refs.multiselect.$el.focus());
    },
    convertName(title) {
      let name = title;
      const word_length = 72;
      if (name.toString().length >= word_length) {
        name = name.toString().substr(0, word_length) + '...';
      }
      return name;
    },
    captionRating(rating) {
      const r = Number(rating);
      switch (true) {
        case r >= 1.0 && r <= 1.9:
          return 'It’s Not For Me!';
        case r >= 2.0 && r <= 2.9:
          return 'Doesn’t Meet Expectation!';
        case r >= 3.0 && r <= 3.9:
          return 'Just Okay!';
        case r >= 4.0 && r <= 4.9:
          return 'Excellent product!';
        case r === 5.0:
          return 'Ultimate holy-grail!';
        default:
          return '';
      }
    },
    clearForm() {
      this.temp.attributes = {};
      this.review.ratingTypes = {};
      this.isRecommended = '';
      this.isRepurchase = '';
      this.$store.commit('setReviewDetails', '');
      this.tags = '';
      this.$store.commit('resetDataRelatedWriteReview');
    },
    discardReview() {
      this.$router.push('/review/add');
      this.clearForm();
      this.$validator.reset();
    },
    confirmation() {
      if (this.user.is_expert_reviewer) {
        this.updateReview();
      } else {
        this.$store.commit('toggleModalGlobalState', { modalName: 'confirmationEdit' });
      }
    },
    confirmationRemovePhoto(key) {
      this.$store.commit('setSavedKeyRemovePhoto', key);
      this.$store.commit('toggleModalGlobalState', { modalName: 'confirmationPhoto' });
    },
    editProductShot(productShotKey) {
      const selected = this.$store.state.writeReview.productShot[productShotKey];
      this.$store.commit('setEditPhotoPropertyOf', { name: 'file', value: selected.file });
      this.$store.commit('setEditPhotoPropertyOf', { name: 'caption', value: selected.caption });

      this.$store.dispatch('setModalEditPhoto', { newValModal: true, productShotKey: productShotKey });
    },
    openModal() {
      this.$store.dispatch('setModalSearchProduct', true);
    },
    openModalUploadPhoto() {
      this.$store.dispatch('setModalUploadPhoto', true);
    },
    searchTag(keyword) {
      if (!keyword || keyword.length < 3) {
        if (typeof source !== 'undefined') {
          this.state.tag.isLoading = false;
          source.cancel();
        }
        return;
      }

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      this.state.tag.isLoading = true;
      this.$MS_SOCO_PUBLIC_API_URL('product/tags', {
        params: {
          keyword: keyword,
          skip: 0,
          limit: 10,
        },
      })
        .then(
          function (response) {
            if (response.status == 200) {
              this.options.tag = response.data.data;
              this.state.tag.isLoading = false;
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            if (axios.isCancel(error)) {
              return true;
            } else {
              console.log(error);
              // if(this.$store.state.consoleLogMode){console.log('Error: ' + error)}
            }
          }.bind(this)
        );
    },
    searchUser(keyword) {
      if (!keyword || keyword.length < 3) {
        if (typeof source !== 'undefined') {
          this.state.tag.isLoading = false;
          source.cancel();
        }
        return;
      }

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      this.state.fakeUser.isLoading = true;

      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/search?keyword=${keyword}`, {
          params: {
            skip: 0,
            limit: 10,
          },
          cancelToken: source.token,
        })
        .then((response) => {
          if (response.status === 200) {
            this.options.fakeUser = response.data.data;
          }
          this.state.fakeUser.isLoading = false;
        })
        .catch((err) => {
          //if (err.message !== false) this.state.fakeUser.isLoading = false
        });
    },
    setRating(options) {
      this.$store.commit('setReviewRatingType', { name: options.name, value: options.value });
    },
    toggleHeightMultiselect() {
      const $fieldMultiselectSuggestion = this.$SO('.fieldarea--multiselect--tag .multiselect__content-wrapper');
      const $fieldMultiselectEl = this.$SO('.fieldarea--multiselect--tag');
      const height = this.$SO('.fieldarea--multiselect--tag .multiselect__tags-wrap').length
        ? this.$SO('.fieldarea--multiselect--tag .multiselect__tags-wrap')[0].offsetHeight + 20
        : 0;

      $fieldMultiselectSuggestion.css({ marginTop: height });
      $fieldMultiselectEl.css({ marginBottom: height });
    },
    backStep() {
      if (this.layerSteps.give_rating) {
        this.$store.commit('toggleModalGlobalState', { modalName: 'editReview' });
      } else if (this.layerSteps.write_review) {
        this.layerSteps.write_review = false;
        this.layerSteps.give_rating = true;
      } else if (this.layerSteps.recommend) {
        this.layerSteps.recommend = false;
        this.layerSteps.write_review = true;
      }
    },
    nextStep() {
      if (this.layerSteps.give_rating) {
        this.layerSteps.give_rating = false;
        this.layerSteps.write_review = true;
      } else if (this.layerSteps.write_review) {
        this.layerSteps.write_review = false;
        this.layerSteps.recommend = true;
      }
    },
    showProductDetail(combination) {
      let variant = '';
      if (combination && combination.attribute) {
        Object.keys(combination.attribute).map((attr, index) => {
          // add comma to string, except if only one, or last one
          if (index > 0 && index < Object.keys(combination.attribute).length) {
            variant = `${variant}, `;
          }
          if (attr !== 'non_specify') {
            variant = variant + `${attr.charAt(0).toUpperCase()}${attr.slice(1)}: ${combination.attribute[attr].name}`;
          }
        });
      }
      return variant;
    },
    onProcessFile(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        this.validationFile(files[i], files.length);
        this.openModalUploadPhoto();
      }
    },
    validationFile(file, totalFiles = 1) {
      const totalMaxFile = 6;
      const isReachTotalMaxFile =
        this.productShot.length + totalFiles + this.temporaryProductShot.length > totalMaxFile;

      if (file) {
        if (file.size < 5242880 && /png|jpg|jpeg/.test(file.type) && !isReachTotalMaxFile) {
          const self = this;
          new Compressor(file, {
            height: 600,
            width: 600,
            mimeType: 'image/png',
            quality: 0.8,
            success(fileAfterCompress) {
              self.fileToBase64(fileAfterCompress);
            },
            error(e) {
              console.log(e.message);
            },
          });

          this.errorUploadPhoto = false;
          this.messageErrorUploadPhoto = '';
        }

        if (!(file.size < 5242880)) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'Ukuran maksimum 5MB';
        }

        if (!/png|jpg|jpeg/.test(file.type)) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'File harus png, jpg, jpeg.';
        }

        if (isReachTotalMaxFile) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'File yang akan anda upload telah mencapai batas maksimal 6';
        }
      }
    },
    fileToBase64(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        this.$store.dispatch('addDataTemporaryProductShot', reader.result);
      }.bind(this);
      reader.onerror = function (error) {
        console.log(error);
      };
    },
    updateReview() {
      let payload;
      let average_rating = 0;
      const new_review = JSON.parse(JSON.stringify(this.review));

      this.state.onProgressSubmit = true;

      this.$validator.validateAll().then((response) => {
        if (response) {
          payload = {
            source: window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile',
            product_id: Number(this.review.product_id),
            details: this.review.details,
            is_recommended: this.review.is_recommended,
            is_repurchase: this.review.is_repurchase,
            images: [],
            product: {
              id: Number(this.review.product_id),
              combination: '',
            },
            tags: [],
            duration_of_used: this.review.duration_of_used,
          };

          new_review.source = payload.source;
          new_review.details = payload.details;
          new_review.is_recommended = payload.is_recommended;
          new_review.is_repurchase = payload.is_repurchase;

          if (this.$SO.size(this.review.product.combination)) {
            this.$SO.each(this.productCombinationsAttribute, (key, combination) => {
              if (combination.id === this.review.product.combination.id) {
                payload.product.combination = this.productCombinationsAttribute[key];
                return false;
              }
            });
          }

          payload.product.variant = payload.product.combination ? payload.product.combination.variant : '';

          if (this.$SO.size(this.productShot)) {
            this.$SO.each(this.productShot, (key, objProduct) => {
              if (objProduct.file) {
                payload.images.push({
                  name: objProduct.file,
                  description: objProduct.caption,
                });
              }
            });

            new_review.images = payload.images;
          }

          if (this.$SO.size(this.review.user)) {
            payload.user = {
              id: this.review.user.id,
              username: this.review.user.user_name,
              name: `${this.review.user.name}`,
            };
          }

          this.$SO.each(this.review.tags, (i, tag) => {
            payload.tags.push({ name: tag.name });
          });

          this.$SO.each(this.review.ratingTypes, (key, prop) => {
            payload[`is_${key}`] = this.review.ratingTypes[key].value;
            new_review[key] = this.review.ratingTypes[key].value;
            average_rating += Number(this.review.ratingTypes[key].value);
          });

          new_review.average_rating = average_rating / this.review.lisRatingTypes.length;
          new_review.counter_star = new_review.average_rating;
          new_review.is_editable = true;
          if (this.user.is_expert_reviewer) {
            payload['is_editable'] = true;
          }
          payload['edited_at'] = new Date();
          if (payload.images.length == 0) {
            delete payload.images;
          }

          this.$MS_SOCO_PUBLIC_API_URL
            .put(`reviews/${this.review['_id']}`, payload)
            .then((response) => {
              if (response.status == '200') {
                const on = /product/.test(this.$route.path) ? 'product' : 'recent';
                this.$store.commit('review/EDIT_REVIEW', {
                  on: on,
                  value: new_review,
                  reviewId: this.review._id,
                });
                this.$toasted.global.show('Review anda berhasil diedit.');
                this.state.onProgressSubmit = false;
              } else {
                if (response.status == '403') {
                  this.$toasted.global.error('Konten review yang ingin kamu masukkan sudah ada.');
                } else {
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                }
                this.state.onProgressSubmit = false;
              }
              this.closeModal();
            })
            .catch((error) => {
              if (error.response) {
                if (error.response && error.response.data && error.response.data.message) {
                  if (error.response.data.errorCode == 'DUPLICATE_USER_REVIEW') {
                    this.$store.commit(
                      'setReviewErrorMessage',
                      'Maaf, Kamu sudah pernah review produk atau produk dengan kombinasi ini sebelumnya.'
                    );
                  } else {
                    this.$store.commit('setReviewErrorMessage', error.response.data.message);
                  }
                  this.$store.commit('toggleModalGlobalState', { modalName: 'reviewError' });
                } else if (error.response.status == 403) {
                  this.$store.commit('setReviewErrorMessage', 'Konten review yang ingin kamu masukkan sudah ada.');
                  this.$store.commit('toggleModalGlobalState', { modalName: 'reviewError' });
                } else {
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                }
              } else {
                this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
              }
              this.state.onProgressSubmit = false;
              // this.closeModal();
            });
        } else {
          this.state.onProgressSubmit = false;
          if (document.getElementById(this.$validator.errors.items[0].field)) {
            document.getElementById(this.$validator.errors.items[0].field).scrollIntoView();
            window.scrollBy(0, -85);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.p-0 {
  padding: 0;
}
.p-16 {
  padding: 0 16px;
}
.form-group .input-mandatory {
  display: none;
}
</style>
